@if (!noFooterRequired()) {
  <footer>
    <!-- ログイン前に表示するfooter -->
    @if (!user) {
      <div class="before-login-footer">
        @if (!hiddenLink) {
          <ul class="footer-link-list">
            <li class="footer-link">
              <a
                spenLink
                href="https://support.classi.jp/hc/ja"
                target="_blank"
                rel="noopener"
                >ヘルプページ</a
              >
            </li>
            <li class="footer-link">
              <a
                spenLink
                href="https://status.classi.jp/"
                target="_blank"
                rel="noopener"
                >サービス稼働情報</a
              >
            </li>
          </ul>
        }
        <div class="copyright">© Benesse Corporation. All rights reserved</div>
      </div>
    }
    <!-- ログイン後にuserを取得できる状態の時に表示するfooter -->
    @if (user) {
      <div>
        <spen-footer
          [userTypeId]="(user | currentUser).userTypeId"
        ></spen-footer>
      </div>
    }
  </footer>
}
